export default __webpack_public_path__ + "static/media/running.38c63352.png";